module.exports = __webpack_public_path__ + "img/bmcl_gallery2.cdfad90d.jpg";